<template>
  <ul class="event_details_list">
    <template v-for="(value, propertyName) in this._props.event_details">
      <li v-bind:key="propertyName">{{ propertyName | dashToSpace }}: {{ value }}</li>
    </template>
  </ul>
</template>
<script>
export default {
  name: "EventDetails",
  props: ["event_details"]
};
</script>
<style src="./EventDetails.scss" lang="scss" scoped/>
